import axios from 'axios';
import type { ApiResponse } from '../services/api';

export interface ShortExamInfo {
  available: number;
  required: number;
}

/** /exam/start 가 '승인된 문항 부족'(409)으로 거절했는지 확인합니다. */
export const getShortExamInfo = (error: unknown): ShortExamInfo | null => {
  if (!axios.isAxiosError<ApiResponse>(error)) return null;
  const body = error.response?.data;
  if (body?.error?.code !== 'INSUFFICIENT_QUESTIONS') return null;
  const details = (body.error.details || {}) as Partial<ShortExamInfo>;
  return { available: Number(details.available) || 0, required: Number(details.required) || 0 };
};

export const getApiErrorCode = (error: unknown): string | undefined =>
  axios.isAxiosError<ApiResponse>(error) ? error.response?.data?.error?.code : undefined;

export const getApiErrorMessage = (error: unknown): string | undefined =>
  axios.isAxiosError<ApiResponse>(error) ? error.response?.data?.error?.message : undefined;

export const shortExamMessage = ({ available, required }: ShortExamInfo) =>
  `이 시험은 지금 검수가 끝난 문항이 ${available}개라 실제 시험(${required}문항)보다 짧게 진행됩니다. ` +
  '점수와 합격 여부는 실제 시험과 그대로 비교하기 어렵습니다.';
